import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import {createProvider} from './vue-apollo';

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/build/scss/mdb.scss';
// import './assets/scss/app.scss';

import {library} from '@fortawesome/fontawesome-svg-core';
import {faTrash, faMinusCircle, faTimes, faRedoAlt, faInbox, faChevronLeft,
  faCheck, faCheckDouble, faCheckCircle, faCheckSquare, faExclamationTriangle,
  faTachometerAlt, faEnvelopeOpenText, faClipboardList, faMailBulk, faFileAlt,
  faCircleNotch, faEnvelope, faFileInvoice, faSearch, faPlus, faSignInAlt,
  faUser, faPen, faPaperPlane, faList, faBell, faBellSlash,
  faExclamationCircle, faBan,
} from '@fortawesome/free-solid-svg-icons';
import {faFacebookSquare, faInstagram, faTwitterSquare,
} from '@fortawesome/free-brands-svg-icons';
import {faThumbsUp, faSquare, faCircle,
} from '@fortawesome/free-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

library.add(faTrash, faMinusCircle, faTimes, faRedoAlt, faInbox, faChevronLeft,
    faCheck, faCheckDouble, faCheckCircle, faCheckSquare, faExclamationTriangle,
    faTachometerAlt, faEnvelopeOpenText, faClipboardList, faMailBulk, faFileAlt,
    faCircleNotch, faEnvelope, faFileInvoice, faSearch, faPlus, faSignInAlt,
    faUser, faPen, faPaperPlane, faList, faBell, faBellSlash,
    faExclamationCircle, faBan,
    // Brands
    faFacebookSquare, faInstagram, faTwitterSquare,
    // Regular
    faThumbsUp, faSquare, faCircle,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app');
